import { AccountIdentity, accountIdentity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class GuestAccountSignInRequestDTO extends BaseRequestDTO<GuestAccountSignInResponseDTORaw> {
  private static validation = JsonSchemaValidator.compile(
    GuestAccountSignInRequestDTO.validationSchema()
  );

  constructor(value: GuestAccountSignInResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(GuestAccountSignInRequestDTO.validation, value)
    );
  }

  override toJSON(): object {
    return this.value;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["identity"],
      properties: {
        identity: accountIdentity
      },
      additionalProperties: false
    };
  }
}

interface GuestAccountSignInResponseDTORaw {
  identity: AccountIdentity;
}
